<button
  type="button"
  role="checkbox"
  class="sz-checkbox-card"
  [class.sz-checkbox-card--checked]="value()"
  [class.sz-checkbox-card--disabled]="disabledState()"
  [disabled]="disabledState()"
  [attr.aria-checked]="value()"
  (click)="toggle()">
  <span class="sz-checkbox-card__box" aria-hidden="true">
    @if (value()) {
      <sz-icon name="check" [size]="14" />
    }
  </span>
  <span class="sz-checkbox-card__body">
    <span class="sz-checkbox-card__label">{{ label() }}</span>
    @if (description(); as desc) {
      <span class="sz-checkbox-card__desc">{{ desc }}</span>
    }
  </span>
</button>
